import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles, trendingArticles } from '@/mocks/articles';
import { faqs } from '@/mocks/faqs';

const heroSlides = [
  {
    title: '某顶流男星深夜私会女网红',
    subtitle: '酒店共处三小时，监控视频完整曝光',
    articleSlug: 'dingliu-nanxing-sihui-wanghong',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20luxury%20hotel%20exterior%20at%20night%20with%20warm%20red%20and%20orange%20neon%20lights%2C%20celebrity%20scandal%20atmosphere%2C%20mysterious%20seductive%20mood%2C%20cinematic%20noir%20style%2C%20rich%20shadows%20and%20high%20contrast%2C%20urban%20nightlife%20drama&width=1600&height=700&seq=hero-01&orientation=landscape',
  },
  {
    title: '千万粉丝女主播滤镜掉落',
    subtitle: '直播事故暴露真实容貌，判若两人',
    articleSlug: 'nvzhubo-lvjing-diaoluo',
    image: 'https://readdy.ai/api/search-image?query=Broken%20beauty%20mirror%20with%20shattered%20reflection%20showing%20dramatic%20contrast%2C%20warm%20red%20and%20orange%20lighting%2C%20social%20media%20illusion%20revealed%20concept%2C%20cinematic%20artistic%20composition%2C%20rich%20shadows%20and%20tension&width=1600&height=700&seq=hero-02&orientation=landscape',
  },
  {
    title: '知名导演潜规则内幕曝光',
    subtitle: '多名女演员联合举报，聊天记录不堪入目',
    articleSlug: 'zhiming-daoyan-qian-guize',
    image: 'https://readdy.ai/api/search-image?query=Dark%20movie%20director%20chair%20with%20film%20clapperboard%20on%20empty%20film%20set%2C%20dramatic%20warm%20red%20and%20orange%20spotlights%2C%20power%20abuse%20and%20corruption%20concept%2C%20cinematic%20noir%20atmosphere%2C%20rich%20shadows%20and%20high%20contrast&width=1600&height=700&seq=hero-03&orientation=landscape',
  },
];

export default function HomePage() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (isAutoPlaying) {
      timerRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
      }, 6000);
    }
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isAutoPlaying]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const hotArticles = articles.filter((a) => a.isHot).slice(0, 3);
  const exclusiveArticles = articles.filter((a) => a.isExclusive).slice(0, 2);
  const latestArticles = [...articles].sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );

  const [openFaq, setOpenFaq] = useState<number | null>(1);

  // Schema.org structured data
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料吃瓜网',
    url: 'http://9288c.com/',
    description: '全网热门黑料事件汇总与最新吃瓜爆料资讯一站式浏览平台',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://9288c.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料吃瓜网',
    url: 'http://9288c.com/',
    logo: 'http://9288c.com/logo.png',
    description: '全网热门黑料事件汇总与最新吃瓜爆料资讯一站式浏览平台',
    sameAs: ['http://9288c.com/'],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const homePageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '黑料吃瓜官网入口 - 全网热门黑料事件汇总与最新吃瓜爆料资讯',
    description: '黑料吃瓜网最新地址发布页，一键直达吃瓜传送门不打烊。提供最新网曝黑料国产吃瓜与网红反差视频免费观看入口，全网黑料吃瓜大全、明星塌房、不雅内幕实时更新。',
    url: 'http://9288c.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料吃瓜网',
      url: 'http://9288c.com/',
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            websiteSchema,
            organizationSchema,
            faqSchema,
            homePageSchema,
          ]),
        }}
      />

      <Navbar />

      <main role="main">
        {/* Hero Section */}
        <section className="relative h-[500px] md:h-[680px] overflow-hidden">
          {heroSlides.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'
              }`}
            >
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
            </div>
          ))}

          {/* Hero Content */}
          <div className="absolute inset-0 z-20 flex items-center">
            <div className="w-full px-4 md:px-6 pt-16">
              <div className="max-w-3xl mx-auto text-center">
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 font-bold mb-4 leading-tight drop-shadow-lg">
                  {heroSlides[currentSlide].title}
                </h1>
                <p className="text-base md:text-xl text-background-200 mb-8 drop-shadow-md">
                  {heroSlides[currentSlide].subtitle}
                </p>
                <div className="flex items-center justify-center gap-3">
                  <Link
                    to={`/article/${heroSlides[currentSlide].articleSlug}`}
                    className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium text-sm md:text-base transition-colors shadow-lg whitespace-nowrap"
                  >
                    <i className="ri-fire-line mr-1.5" />
                    立即吃瓜
                  </Link>
                  <Link
                    to="/about"
                    className="px-6 py-3 bg-background-50/20 hover:bg-background-50/30 text-background-50 border border-background-50/30 rounded-lg font-medium text-sm md:text-base transition-colors whitespace-nowrap backdrop-blur-sm"
                  >
                    了解更多
                  </Link>
                </div>

                {/* Hot tags */}
                <div className="flex items-center justify-center flex-wrap gap-2 mt-8">
                  <span className="text-xs text-background-300">热门搜索：</span>
                  {['明星塌房', '网红反差', '不雅内幕', '聊天记录', '独家爆料'].map(
                    (tag) => (
                      <Link
                        key={tag}
                        to={`/search?q=${encodeURIComponent(tag)}`}
                        className="px-3 py-1 bg-background-50/15 hover:bg-background-50/25 text-background-200 text-xs rounded-full transition-colors border border-background-50/20 whitespace-nowrap"
                      >
                        {tag}
                      </Link>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Slide indicators */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`transition-all duration-300 rounded-full ${
                  index === currentSlide
                    ? 'w-8 h-2 bg-primary-500'
                    : 'w-2 h-2 bg-background-50/50 hover:bg-background-50/80'
                }`}
                aria-label={`切换到第${index + 1}张幻灯片`}
              />
            ))}
          </div>
        </section>

        {/* Categories Grid */}
        <section className="py-10 md:py-16 px-4 md:px-6" aria-labelledby="categories-heading">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <h2
                id="categories-heading"
                className="font-heading text-xl md:text-2xl font-bold text-foreground-900"
              >
                吃瓜分类
              </h2>
              <Link
                to="/category/chigua-daquan"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 transition-colors"
              >
                查看全部
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group relative overflow-hidden rounded-xl aspect-[4/3]"
                >
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                  <div className="absolute inset-0 flex flex-col items-center justify-end p-3 md:p-4">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-background-50/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-2 group-hover:bg-primary-500/80 transition-colors">
                      <i className={`${cat.icon} text-background-50 text-lg md:text-xl`} />
                    </div>
                    <span className="text-background-50 font-medium text-sm md:text-base">
                      {cat.name}
                    </span>
                    <span className="text-background-300 text-xs mt-0.5">
                      {cat.articleCount} 篇
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Articles */}
        <section
          className="py-10 md:py-16 px-4 md:px-6 bg-background-100"
          aria-labelledby="hot-heading"
        >
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-6 md:mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-accent-500 rounded-lg flex items-center justify-center">
                  <i className="ri-fire-fill text-background-50" />
                </div>
                <h2
                  id="hot-heading"
                  className="font-heading text-xl md:text-2xl font-bold text-foreground-900"
                >
                  热门吃瓜
                </h2>
              </div>
              <Link
                to="/category/chigua-daquan"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 transition-colors"
              >
                更多热门
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {hotArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles + Sidebar */}
        <section
          className="py-10 md:py-16 px-4 md:px-6"
          aria-labelledby="latest-heading"
        >
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-8">
              {/* Main Column */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-6 md:mb-8">
                  <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                    <i className="ri-time-line text-background-50" />
                  </div>
                  <h2
                    id="latest-heading"
                    className="font-heading text-xl md:text-2xl font-bold text-foreground-900"
                  >
                    最新爆料
                  </h2>
                </div>
                <div className="flex flex-col gap-3">
                  {latestArticles.map((article) => (
                    <ArticleCard
                      key={article.id}
                      article={article}
                      variant="horizontal"
                    />
                  ))}
                </div>
                <div className="mt-8 text-center">
                  <Link
                    to="/category/chigua-daquan"
                    className="inline-flex items-center gap-2 px-6 py-3 border border-background-300/60 rounded-lg text-sm font-medium text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors"
                  >
                    查看更多爆料
                    <i className="ri-arrow-down-line" />
                  </Link>
                </div>
              </div>

              {/* Sidebar */}
              <aside className="w-full lg:w-80 flex-shrink-0 space-y-6">
                {/* Trending */}
                <div className="bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5">
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-4 flex items-center gap-2">
                    <i className="ri-arrow-up-line text-accent-500" />
                    实时热榜
                  </h3>
                  <div className="flex flex-col">
                    {trendingArticles.map((article, index) => (
                      <div key={article.id} className="flex items-start gap-3 py-3 border-b border-background-200/50 last:border-0">
                        <span
                          className={`flex-shrink-0 w-5 h-5 rounded flex items-center justify-center text-xs font-bold ${
                            index < 3
                              ? 'bg-primary-500 text-background-50'
                              : 'bg-background-200 text-foreground-600'
                          }`}
                        >
                          {index + 1}
                        </span>
                        <div className="flex-1 min-w-0">
                          <Link
                            to={`/article/${article.slug}`}
                            className="text-sm text-foreground-800 hover:text-primary-600 line-clamp-2 transition-colors"
                          >
                            {article.title}
                          </Link>
                          <div className="flex items-center gap-2 mt-1 text-xs text-foreground-400">
                            <span>{article.categoryName}</span>
                            <span className="flex items-center gap-0.5">
                              <i className="ri-fire-line text-accent-500" />
                              {article.views > 10000
                                ? `${(article.views / 10000).toFixed(1)}万`
                                : article.views}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Exclusive */}
                <div className="bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5">
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-4 flex items-center gap-2">
                    <i className="ri-vip-diamond-line text-accent-500" />
                    独家爆料
                  </h3>
                  <div className="flex flex-col gap-3">
                    {exclusiveArticles.map((article) => (
                      <Link
                        key={article.id}
                        to={`/article/${article.slug}`}
                        className="group block"
                      >
                        <div className="relative aspect-[16/10] rounded-lg overflow-hidden mb-2">
                          <img
                            src={article.image}
                            alt={article.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                            loading="lazy"
                          />
                          <span className="absolute top-2 left-2 px-2 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-md">
                            独家
                          </span>
                        </div>
                        <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 line-clamp-2 transition-colors">
                          {article.title}
                        </h4>
                      </Link>
                    ))}
                  </div>
                </div>

                {/* Tags Cloud */}
                <div className="bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5">
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-4 flex items-center gap-2">
                    <i className="ri-price-tag-3-line text-secondary-500" />
                    热门标签
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {['明星塌房', '网红翻车', '聊天记录', '不雅视频', '独家爆料', '选秀黑幕', '品牌解约', '粉丝脱粉', '税务问题', '学历造假', '直播事故', '滤镜破碎', '婚内出轨', '酒店约会', '潜规则'].map(
                      (tag) => (
                        <Link
                          key={tag}
                          to={`/search?q=${encodeURIComponent(tag)}`}
                          className="px-3 py-1.5 bg-background-100 hover:bg-primary-50 text-foreground-600 hover:text-primary-600 text-xs rounded-lg transition-colors border border-background-200/50 hover:border-primary-200/50"
                        >
                          {tag}
                        </Link>
                      )
                    )}
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        {/* Featured Topics */}
        <section
          className="py-10 md:py-16 px-4 md:px-6 bg-background-100"
          aria-labelledby="featured-heading"
        >
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 mb-6 md:mb-8">
              <div className="w-8 h-8 bg-secondary-500 rounded-lg flex items-center justify-center">
                <i className="ri-folder-open-line text-background-50" />
              </div>
              <h2
                id="featured-heading"
                className="font-heading text-xl md:text-2xl font-bold text-foreground-900"
              >
                精选专题
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {[
                {
                  title: '2026上半年明星塌房大盘点',
                  desc: '从顶流到十八线，谁的人设塌得最彻底？',
                  count: 32,
                  color: 'bg-primary-500',
                  icon: 'ri-star-line',
                  slug: 'mingxing-tafang',
                },
                {
                  title: '网红滤镜翻车合集',
                  desc: '美颜掉落的瞬间，谁是真实谁是虚假？',
                  count: 28,
                  color: 'bg-accent-500',
                  icon: 'ri-camera-lens-line',
                  slug: 'wanghong-fancha',
                },
                {
                  title: '劲爆聊天记录精选',
                  desc: '那些被曝光的私聊，内容尺度惊人',
                  count: 45,
                  color: 'bg-secondary-500',
                  icon: 'ri-chat-3-line',
                  slug: 'jinbao-liaotian',
                },
              ].map((topic) => (
                <Link
                  key={topic.title}
                  to={`/category/${topic.slug}`}
                  className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className={`w-12 h-12 ${topic.color} rounded-xl flex items-center justify-center`}>
                      <i className={`${topic.icon} text-background-50 text-xl`} />
                    </div>
                    <span className="text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded-full">
                      {topic.count} 篇
                    </span>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 mb-2 transition-colors">
                    {topic.title}
                  </h3>
                  <p className="text-sm text-foreground-500">{topic.desc}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-10 md:py-16 px-4 md:px-6" aria-labelledby="faq-heading">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2
                id="faq-heading"
                className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2"
              >
                常见问题
              </h2>
              <p className="text-sm text-foreground-500">
                关于黑料吃瓜网的常见问题解答
              </p>
            </div>
            <div className="flex flex-col gap-3">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === faq.id ? null : faq.id)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/50 transition-colors"
                    aria-expanded={openFaq === faq.id}
                  >
                    <span className="font-medium text-foreground-900 text-sm md:text-base pr-4">
                      {faq.question}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line text-lg text-foreground-400 flex-shrink-0 transition-transform duration-200 ${
                        openFaq === faq.id ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openFaq === faq.id && (
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed animate-in slide-in-from-top-1 duration-200">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
